export default {
  namespaced: true,
  state: {
    results: { total: -1, list: [] }
  },
  getters: {
    getExports: (state) => {
      return state.results
    }
  },
  mutations: {
    setResults (state, results) {
      state.results = results
    }
  }
}
